module.exports = __webpack_public_path__ + "static/media/hotelmontefiore_thumb_even.462f71f6.webp";